import * as React from 'react';

import cx from 'classnames';

import { ImageUploadContext } from '~analytics/adapters/ImageEventAdapterTypes';
import ImageField from '~shared/components/ImageField/ImageField';
import ImagePreviewer from '~shared/components/ImageField/ImagePreviewer';
import { QuizEditorIsUploadingImageContext } from '~teacher/components/QuizEditor/QuizEditorIsUploadingImage';
import { ImageResource } from '~teacher/models/quizzes';

interface Props {
  /** Is the field editable? */
  isReadOnly: boolean;
  image: ImageResource;
  imageFieldLabel?: string;
  imageClearLabel?: string;
  onImageChange?: (image: string) => void;
  imageFieldDisabled?: boolean;
  addImageIntercept?: () => void;
  context: ImageUploadContext;
}

const ImageFieldDisplay: React.FC<Props> = (props) => {
  const {
    isReadOnly,
    image,
    imageFieldLabel,
    imageClearLabel,
    onImageChange,
    imageFieldDisabled,
    addImageIntercept,
    context,
  } = props;
  const imageURL = image?.urlS ?? image?.url;
  const imageValue = imageURL ? [imageURL] : null;
  const imageDisplayClass = React.useMemo(
    () =>
      cx('inline-block align-middle overflow-hidden', {
        'my-2 rounded-1': isReadOnly,
        'rounded-2': !isReadOnly,
      }),
    [isReadOnly]
  );

  return !isReadOnly ? (
    <QuizEditorIsUploadingImageContext.Consumer>
      {({ beginUploading, finishUploading }) => (
        <ImageField
          initialImages={imageValue}
          size="inline"
          labelText={imageFieldLabel}
          clearLabel={imageClearLabel}
          disabled={imageFieldDisabled}
          onUpdateImage={onImageChange}
          addImageIntercept={addImageIntercept}
          onBeginUploadingImage={beginUploading}
          onFinishUploadingImage={finishUploading}
          context={context}
        />
      )}
    </QuizEditorIsUploadingImageContext.Consumer>
  ) : imageURL ? (
    <ImagePreviewer
      containerStyle={imageDisplayClass}
      imageStyle="max-h-64"
      imageURL={imageURL}
      showOutline={true}
      allowZoom={isReadOnly}
      zoomImageURL={image?.url}
    />
  ) : null;
};

export default ImageFieldDisplay;
